import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  width: "49.296",
  height: "50",
  viewBox: "0 0 49.296 50",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    fill: "#1974bb",
    d: "M49.209 28.543c-.789-9.146-7.096-15.295-11.984-21.917 2.05-2.996 6.623-2.05 9.934-1.42C42.9 2.211 37.856.476 32.495.003 22.245-.155 14.046 5.837 6.478 12.46c-4.573-1.42-1.42-6.308-1.42-9.776C1.118 8.044-.144 14.036.014 20.186c.158 5.519 2.523 10.88 5.676 15.768l6.623 7.568c-2.208 3.627-6.623 2.05-9.934 1.42 5.361 3.941 11.353 5.203 17.502 5.045 5.52-.158 10.88-2.523 15.61-5.676l7.57-6.623c2.207 2.523 2.68 6.78 1.418 9.934 3.784-5.361 5.204-11.984 4.73-19.08zm-7.254.315a404.56 404.56 0 0 1-4.257 5.204c-2.365 2.68-4.415 3.942-5.361 4.73-3.154 2.365-7.096 3.784-11.037 3.942h-.947l-4.572-4.573c-1.42-1.734-2.68-2.523-4.573-5.203-2.365-3.311-3.784-7.096-3.942-11.038v-1.419l4.415-3.942c5.204-4.572 10.88-8.672 17.975-8.672h.316l3.469 4.573c3.311 4.572 7.726 8.987 8.357 15.294 0 0 .157.946.157 1.104z"
  })]
});